import { ClientEvents } from 'common/events/ClientEvents';
import { useCallback } from 'react';
import { useTracker } from 'src/shared/hooks/useTracker';
import { useDispatch, useSelector } from 'src/store';
import { actions, selectors } from 'src/store/explore';

export const useAllCuisinesShowing = () => {
  const dispatch = useDispatch();
  const tracker = useTracker();
  const isAllCuisinesShowing = useSelector(selectors.selectIsAllCuisinesShowing);

  const hideAllCuisines = useCallback(() => {
    dispatch(actions.hideAllCuisines());
  }, [dispatch, actions.hideAllCuisines]);

  const showAllCuisines = useCallback(() => {
    dispatch(actions.showAllCuisines());
    tracker.track(ClientEvents.EXPLORE_SEE_MORE_CLICK, {});
  }, [dispatch, actions.showAllCuisines]);

  return {
    isAllCuisinesShowing,
    hideAllCuisines,
    showAllCuisines,
  };
};
